import React, { useContext, useState } from "react";
import "./TransactionCard.css";
import { TbCirclePlus, TbClock } from "react-icons/tb";
import RentalModal from "../RentalModal/RentalModal";
import Modal from "../Modal/Modal";
import { SlLocationPin } from "react-icons/sl";
import { LuShoppingBag } from "react-icons/lu";
import { MallContext } from "../../MallContext";
import { useLanguage } from "../../LanguageProvider";

const TransactionCard = ({ type, status, vehicleNo, elapsedTime, remainingTime, serviceType, createdDateTime, willDeliverDateTime, price, isExpired, packageCount, requestID, originalWillDeliverDateTime }) => {
    const { getTranslation } = useLanguage();
    const { mallInfo } = useContext(MallContext);
    const [isOpen, setIsOpen] = useState(false);
    const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
    const typeColors = {
        "Vestiyer İşlemi": "rgba(227, 74, 74, 1)",
        "kid-car": "rgba(133, 74, 227, 1)",
        "pet-car": "rgba(46, 117, 209, 1)",
        "gift": "rgba(227, 74, 74, 1)"
    };

    const statusClasses = {
        "1": "status-processing",
        "3": "status-pending",
        "4": "status-approved",
    };

    const statuslabels = {
        "1": getTranslation("completed"),
        "3": getTranslation("awaitingApproval"),
        "4": getTranslation("approved"),
    };

    const vehicleLabels = {
        "kid-car": getTranslation("toyStroller"),
        "pet-car": getTranslation("petStroller"),
        "gift": getTranslation("giftPackage")
    };

    return (
        <div className="transaction-card">
            <div className="card-header" style={{ backgroundColor: typeColors[type] }}>
                {vehicleLabels[type]}
            </div>
            <div style={{ flexDirection: 'row', display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: '-10px' }}>


                <div className="card-body">

                    {serviceType !== "gift" ?
                        <>
                            <div className="time-display">
                                <span>{status === "4" ? elapsedTime : "00:00:00"}</span>
                                <span className="clock-icon"><TbClock color="rgba(177, 177, 177, 1)" /></span>
                            </div>
                            <p className="subtext">{getTranslation("elapsedVehicleUsageTime")}</p>
                            <p className="vehicle-number">
                                {getTranslation("vehicleNumber")} <span>{vehicleNo}</span>
                            </p>
                        </> : <>
                            <p className="vehicle-number">
                                {getTranslation("piece")}: <span>{packageCount}</span>
                            </p>
                        </>
                    }



                </div>

                {serviceType !== "gift" &&
                    <div className="card-body-right">
                        <TbCirclePlus onClick={() => setIsOpen(true)} size={50} color="rgba(193, 193, 193, 1)" strokeWidth={0.9} />
                        {serviceType !== "gift" && <div style={{ width: '52px', height: '50px' }}></div>}
                        <div className={`status-badge ${isExpired ? "status-overdue" : statusClasses[status]}`}>{isExpired ? getTranslation("timeExceeded") : statuslabels[status]}</div>
                    </div>
                }


            </div>

            <div className="card-footer">
                {serviceType !== "gift" ? <span className="remaining-time">{getTranslation("remainingTime")} {remainingTime}</span> : <span className="remaining-time"></span>}
                <span className="details-button" onClick={() => setIsDetailModalOpen(true)}>{getTranslation("details")}</span>
            </div>

            <RentalModal setIsOpen={setIsOpen} isOpen={isOpen} type="extend" serviceType={serviceType} requestID={requestID} willDeliverDateTime={originalWillDeliverDateTime} />
            <Modal isOpen={isDetailModalOpen} setIsOpen={setIsDetailModalOpen} title={getTranslation("details")} subtitle={getTranslation("rentalDetails")}>

                <div className="detail-section-no-holder">
                    {serviceType !== "gift" ? <span className="detail-section-no-text">{getTranslation("vehicleNumber")} </span> : <span className="detail-section-no-text">{getTranslation("piece")}: </span>}
                    {serviceType !== "gift" ? <span className="detail-section-no-chip">{vehicleNo}</span> : <span className="detail-section-no-chip">{packageCount}</span>}
                    <div className={`status-badge ${statusClasses[status]}`} style={{ margin: 0 }}>{statuslabels[status]}</div>
                </div>

                <div className="detail-section-info-holder">
                    <div className="detail-section-info-row">
                        <div className="detail-section-info-title">
                            <TbClock style={{ marginRight: '5px' }} />  {getTranslation("startTime")}
                        </div>
                        <div className="detail-section-info-value">
                            {createdDateTime}
                        </div>
                    </div>

                    {serviceType !== "gift" && <div className="detail-section-info-row">
                        <div className="detail-section-info-title">
                            <TbClock style={{ marginRight: '5px' }} />  {getTranslation("endTime")}
                        </div>
                        <div className="detail-section-info-value">
                            {willDeliverDateTime}
                        </div>
                    </div>
                    }

                    <div className="detail-section-info-row">
                        <div className="detail-section-info-title">
                            <SlLocationPin style={{ marginRight: '5px' }} />  {mallInfo?.mallTitle}
                        </div>
                    </div>

                    {/* <div className="detail-section-info-row">
                        <div className="detail-section-info-title">
                            <LuShoppingBag style={{ marginRight: '5px' }} /> Araç Adedi:
                        </div>
                        <div className="detail-section-info-value">
                            1
                        </div>
                    </div> */}
                </div>

                {serviceType !== "gift" &&
                    <div style={{ width: '100%', alignItems: 'center', justifyContent: 'center', display: 'flex', marginTop: '19.05px' }}>
                        <div className="detail-section-remaining-time">
                            {getTranslation("remainingTime")} {remainingTime}
                        </div>
                    </div>
                }

                <div className="fee-info" style={{ marginBottom: '0px' }}>
                    <span style={{ width: '80%', borderBottom: '1px solid rgba(230, 230, 230, 1)', paddingBottom: '10px', alignItems: 'center', justifyContent: 'center', display: 'flex', color: 'rgba(72, 72, 72, 1)', fontSize: '16px', fontWeight: '600', marginTop: '26px', marginBottom: '11px' }}>
                        {getTranslation("feeInformation")}
                    </span>
                    <div className="fee-amount" style={{ fontSize: '24px' }}>{price} TL</div>
                    {/* <div className="fee-or" style={{ fontSize: '14px' }}>ya da 75 TL</div> */}
                </div>
            </Modal>
        </div>
    );
};

export default TransactionCard;
